<app-print-card-background-image-with-color-overlay-and-opacity [cardBackground]="cardBackground">
</app-print-card-background-image-with-color-overlay-and-opacity>
